import { render, staticRenderFns } from "./InvoiceDrawer.vue?vue&type=template&id=65c4c782&scoped=true&"
import script from "./InvoiceDrawer.vue?vue&type=script&lang=js&"
export * from "./InvoiceDrawer.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDrawer.vue?vue&type=style&index=0&id=65c4c782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c4c782",
  null
  
)

export default component.exports